/** English strings — arena and boss names (docs/01 arenas, docs/02 bosses). */
export const enWorld = {
  // Arenas
  'arena.void-open': 'Open Field',
  'arena.nebula-pillars': 'Four Pillars',
  'arena.forest-corridor': 'Center Wall',
  'arena.void-corridor': 'Narrow Corridor',
  'arena.nebula-expanse': 'Great Expanse',
  'arena.forest-chasm': 'Chasm Bridges',
  'arena.magma-cauldron': 'The Cauldron',
  'arena.void-ring': 'Rock Ring',
  'arena.abyss-trench': 'Drowned Trench',
  'arena.abyss-vortex': 'Sinkhole Ring',
  'arena.magma-crossfire': 'Crossfire',
  'arena.nebula-gauntlet': 'The Gauntlet',
  'arena.void-fracture': 'Fractured Floor',
  'arena.forest-grove': 'Old Grove',

  // Bosses
  'boss.sentinel': 'SENTINEL',
  'boss.carrier': 'CRYSTAL CARRIER',
  'boss.hive': 'HIVE MOTHER',
  'boss.serpent': 'TWIN SERPENTS',
  'boss.kraken': 'KRAKEN',
  'boss.centipede': 'CENTIPEDE',
  'boss.quartet': 'THE QUARTET',
  'boss.pyre': 'PYRE CORE',
  'boss.prism': 'PRISM',
  'boss.tide': 'DEEP CALLER',
  'boss.null': 'NULL CROWN',
  'boss.terra': 'GRANITE FIST',
  'boss.gale': 'EYE OF THE STORM',
  'boss.avatar': 'THE AVATAR',
  'boss.mirror': 'MIRROR',
  'boss.splitter': 'SPLITTER',
  'boss.admiral': 'THE ADMIRAL',
  'boss.chronos': 'CHRONOS',
  'boss.magnet': 'MAGNET',
  'boss.bastion': 'BASTION',
  'boss.stalker': 'STALKER',
  'boss.singularity': 'SINGULARITY',
  'boss.broodworm': 'BROODWORM QUEEN',
  'boss.webspinner': 'WEBSPINNER',
  'boss.warden': 'THE WARDEN',
} as const;
